import { createContext, ReactNode, useCallback, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { EmpresaService } from '@/services';
import { Marca } from '@/services/EmpresaService';

// Marca da corretora (cadastro da corretora): nome no menu e título da aba, logo do menu e ícone do site.
// O que não estiver definido usa o padrão Vigento.
export const MARCA_PADRAO = process.env.REACT_APP_TITLE || 'Vigento';
const ICONE_PADRAO = `${process.env.PUBLIC_URL}/favicon.ico`;

type MarcaContextType = {
  titulo: string;
  logo?: string;
  empresa?: string;
  situacao?: string;
  diasTeste?: number;
  acessoCompleto: boolean;
  recarregar(): void;
}

const MarcaContext = createContext<MarcaContextType>({ titulo: MARCA_PADRAO, acessoCompleto: true, recarregar: () => {} });

export const useMarca = () => useContext(MarcaContext);

export const MarcaProvider = ({ children }: { children: ReactNode }) => {
  const { tenant } = useParams();
  const [marca, setMarca] = useState<Marca>();

  const recarregar = useCallback(() => {
    EmpresaService.marca().then(({ data }) => setMarca(data)).catch(() => setMarca(undefined));
  }, []);

  useEffect(() => {
    setMarca(undefined);
    if (tenant) recarregar();
  }, [tenant, recarregar]);

  const titulo = marca?.nomeMenu || MARCA_PADRAO;

  useEffect(() => {
    document.title = titulo;
    document.querySelector<HTMLLinkElement>("link[rel='icon']")?.setAttribute('href', marca?.icone || ICONE_PADRAO);
  }, [titulo, marca?.icone]);

  return (
    <MarcaContext.Provider value={{ titulo, logo: marca?.logo, empresa: marca?.nome, situacao: marca?.situacao,
      diasTeste: marca?.diasTeste ?? undefined, acessoCompleto: marca?.acessoCompleto ?? true, recarregar }}>
      {children}
    </MarcaContext.Provider>
  );
}
